export default {"src":"/_next/static/image/public/images/ic_insurance_modal.44d4966d7349547dcbbe599fec469bc0.svg","height":96,"width":96};